import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomStep from 'workOrderComponents/close/CustomStep';
import Loading from 'layoutComponents/Loading';


class NoAccessReasonStep extends React.Component {

    constructor(props) {
        super(props);
        this.handleReasonChange = this
            .handleReasonChange
            .bind(this);

    }

    componentDidMount() {
        const { workOrderActions, orderId } = this.props;

        workOrderActions.getNoAccessReasonListStarted(orderId)
    }

    handleReasonChange(e, index, value) {
        e.preventDefault();
        const { workOrderActions, orderId } = this.props;
        workOrderActions.setNoAccessReason(value, orderId);
    }

    render() {
        const { orderCloseDetails, stepConfig, orderId, workOrderActions, disabled } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        const selectedReason = orderCloseDetails.getIn(['closeOrderRequest', 'commentRequest', 'noAccessReasonId']);
        const noAccessReasonDetails = orderCloseDetails.get('noAccessReasonDetails');
        const noAccessReasonList = noAccessReasonDetails && noAccessReasonDetails.get('NoAccessReasonList') ?
            noAccessReasonDetails.get('NoAccessReasonList') : [];


        const menuItems = noAccessReasonList
            .map((item, index) => {
                return (<MenuItem
                    key={`no_access_reason_${index}`}
                    value={item.id}
                    primaryText={item.label} />);
            });

        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Reason Unable to Complete`}
                stepConfig={stepConfig}
                stepConfigKey="noAccessReasonStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="noAccessReason">
                <SelectField
                    floatingLabelText="Select Reason"
                    value={selectedReason}
                    disabled={disabled}
                    onChange={this.handleReasonChange}>
                    {menuItems}
                </SelectField>
            </CustomStep>
        );
    }
}

NoAccessReasonStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
    disabled: PropTypes.bool,
    serviceTypeId: PropTypes.string
};

export default NoAccessReasonStep;


// WEBPACK FOOTER //
// ./src/components/noaccess-reason/NoAccessReasonStep.js